export default __webpack_public_path__ + "static/media/logo-dark.72bf788d.png";